import { DateTime } from "luxon"

// date returns in format 'September 8, 2025 @ 9:00AM PT - user's local timezone

export const formatAndSetDates = (
  dates: string[],
  dateSetter: (vals: string[]) => void
) => {
  const isSmallScreen = window.innerWidth < 500 

  const formatted = dates
    .map((iso) => DateTime.fromISO(iso, { zone: "utc" }).toLocal())
    .sort((a, b) => a.toMillis() - b.toMillis())
    .map((dt) => {
      const datePart = dt.toLocaleString(
        isSmallScreen ? DateTime.DATE_MED : DateTime.DATE_FULL
      )
      const timePart = dt.toLocaleString(DateTime.TIME_SIMPLE).toLowerCase()
      return `${datePart} @ ${timePart}`
    })

  dateSetter(formatted)
}